module.exports = __webpack_public_path__ + "static/img/green_animate6.65b7f8de.png";